module.exports = __webpack_public_path__ + "media/Re.e95e040d.wav";